// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoices: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'main',
    items: [
      {
        title: 'menuLeft.dashboard',
        path: PATH_DASHBOARD.general.analytics,
        icon: ICONS.dashboard
      }
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // AGENTS & SKILLS
      {
        title: 'menuLeft.skills',
        path: PATH_DASHBOARD.skills.root,
        icon: ICONS.label,
        children: [
          { title: 'menuLeft.generalSettings', path: PATH_DASHBOARD.skills.global },
          { title: 'agents', path: PATH_DASHBOARD.skills.agents },
          { title: 'menuLeft.skillsAndGroups', path: PATH_DASHBOARD.skills.groups }
          // { title: 'vips', path: PATH_DASHBOARD.skills.vips }
        ],
      },
    ],
  },


  // INTERFACE CLIENT
  // ----------------------------------------------------------------------
  {
    items: [
      // AGENTS & SKILLS
      {
        // title: 'nav.exporter',
        title: 'menuLeft.userInterface',
        path: PATH_DASHBOARD.interface.root,
        icon: ICONS.chat,
        children: [
          { title: 'menuLeft.generalSettings', path: PATH_DASHBOARD.interface.global },
          { title: 'menuLeft.form', path: PATH_DASHBOARD.interface.form },
          { title: 'chat', path: PATH_DASHBOARD.interface.chat }
        ],
      }
    ],
  },


  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'configuration',
    items: [
      // SETTINGS
      {
        title: 'general.settingsTitle',
        path: PATH_DASHBOARD.settings.root,
        icon: ICONS.user,
        // children: [
        //   { title: 'global', path: PATH_DASHBOARD.settings.global },
        //   { title: 'externalRouting', path: PATH_DASHBOARD.settings.externalRouting },
        //   { title: 'tasks', path: PATH_DASHBOARD.settings.tasks },
        //   { title: 'json', path: PATH_DASHBOARD.settings.json }
        // ],
      }
    ],
  },

  
];

export default navConfig;
